import {
  ADDRESS_BOOKS_FETCH_STARTED,
  ADDRESS_BOOKS_FETCH_SUCCEEDED,
  ADDRESS_BOOKS_FETCH_FAILED,
  ADDRESS_BOOKS_CLEAR
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { getRequestOptions } from '#helper';

let abortController = new AbortController();

export const fetchAddressbooks = () => async dispatch => {
  try {
    abortController.abort();
    const addressbooksUrl = webPortalApi.buildApiUrl('addressbook');
    dispatch({
      type: ADDRESS_BOOKS_FETCH_STARTED
    });
    abortController = new AbortController();
    const { signal } = abortController;
    const res = await fetch(addressbooksUrl, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }
    const addressbooks = await res.json();

    dispatch({
      type: ADDRESS_BOOKS_FETCH_SUCCEEDED,
      payload: addressbooks
    });
  } catch (e) {
    if (e.name === 'AbortError') {
      return;
    }
    dispatch({
      type: ADDRESS_BOOKS_FETCH_FAILED,
      error: e
    });
  }
};

export const clear = () => dispatch => {
  abortController.abort();
  dispatch({
    type: ADDRESS_BOOKS_CLEAR
  });
};
